<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <span class="title_head">Add Purchase</span>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12 alert alert-success" v-if="haserror.message!=''" style="text-align:center;">{{haserror.message}}</div>
            </div>
            <b-row>
             <b-col sm="4">
              <b-form-group>
                <label for="name">Supplier Name</label>
                <span style="display: flex;">
                  <model-list-select :list="suppliername" option-value="sup_cmp_name" :custom-text="nameAndnumber" v-model="selectedcustomer" @input="onSelectSup($event)" placeholder="Search Supplier Name" @searchchange="searchsupplier"></model-list-select>&nbsp;&nbsp;
                    <!-- <a href="#/Purchase/supplier/add">
                      <button type="button" class="btn btn-pill btn-primary" route v-b-tooltip.hover title="Add New Supplier"><i class="fa fa-user"></i></button>
                    </a>-->
                    <button v-if="sup_rights === true" type="button" class="btn btn-pill btn-primary" route v-b-tooltip.hover title="Add New Supplier" @click="addSupplier()"><i class="fa fa-user"></i></button>
                  </span>
                  <small class="form-text text-muted"><strong style="color: red;">{{haserror.cust}}</strong></small>
                </b-form-group>
              </b-col>
              
              
              <b-col sm="4">
                <b-form-group>
                  <label for="name">Shop Name</label>
                  <span style="display: flex;">
                    <model-list-select @input="onSelectShp($event)" :list="shopname" option-value="est_shop_id" option-text="est_shop_name" v-model="selectshop" placeholder="Select Shop" @searchchange="searchshops"></model-list-select>&nbsp;&nbsp;
                    <!-- <a href="#/companyinfo/Shop"><button type="button" class="btn btn-pill btn-primary" v-b-tooltip.hover title="Add New Shop"><i class="fa fa-plus"></i></button></a> -->
                    <button type="button" @click="addShop()" class="btn btn-pill btn-primary" v-b-tooltip.hover title="Add New Shop"><i class="fa fa-plus"></i></button>
                  </span>
                  <small class="form-text text-muted"><strong style="color: red;">{{haserror.shop}}</strong></small>
                </b-form-group>
              </b-col>

              <b-col sm="4">
                <b-form-group>
                  <label for="name">Scan Barcode</label>
                  <input type="text" class="form-control" name="barcode" v-model="barcode" @blur="searchBarcode" autocomplete="off"  @keyup="checkShop" placeholder="Enter Product Barcode Number">&nbsp;&nbsp;
                  <small class="form-text text-muted"><strong style="color: red;">{{haserror.barcode}}</strong></small>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <span class="title_head">ITEM DETAILS</span> 
          </div>
          <div class="card-body" style="padding:0px !important;">
            <div class="">
              <table class="table table-striped table-responsive">
                <thead>
                  <tr style="font-size: 12px; text-align: center;">
                    <th width="1%">#</th>
                    <th width="20%">Product Name</th>
                    <th width="6%">Unit</th>
                    <th width="8%">Qty</th> 
                    <th width="8%">Purchase Price/Unit</th>
                    <th width="8%">Sales Price</th> 
                    <th width="12%">Amt Before Tax</th> 
                    <th width="6%" v-if="is_cs_gst">SGST %</th> 
                    <th width="6%" v-if="is_cs_gst">CGST %</th>            
                    <th width="6%" v-if="is_i_gst">IGST %</th> 
                    <th width="13%">Total </th>
                    <th width="6%">Other</th>
                  </tr>
                </thead>
                <tbody id="product_table_body">
                  <tr v-for="(row, index) in rows">
                    <td>
                      <!-- <a href="#/setup/addupdateproduct"><i class="fa fa-plus sale_plus" v-b-tooltip.hover title="Add New Product"></i></a> -->
                      <a style="font-size:14px;color: #20a8d8; cursor:pointer;" @click="addProduct(row,index)"><i class="fa fa-plus" v-b-tooltip.hover title="Add New Product"></i></a>
                    </td>
                    <td>
                      <model-list-select :list="row.productnamex" option-value="product_id" option-text="product_name" v-model="row.selectproductrow" placeholder="Search Product Name" @input="openvariant($event,index)" @searchchange="searchprd3($event,index,row)" style=" white-space: nowrap; -webkit-text-fill-color: rgb(83, 108, 121) !important; height:30px !important; border: 1px solid rgb(194, 207, 214); min-height: 30px; border-radius: 1px; padding-top: 6px;" class="product-drop" id="productlist">
                      </model-list-select>
                      <small style="font-size:  10px;color: darkblue; cursor:pointer;"  v-if="row.productExist !=''"> {{row.productExist}}</small>
                      <small style="font-size: 10px;color: red; cursor:pointer;" @click="openvariant(row,index)" v-if="row.showvariant==true">Variant <i class="fa fa-info-circle"></i>
                        <small style="font-size:  10px;color: darkblue; cursor:pointer;"> {{row.variantrow}}</small>
                      </small>
                      
                      <small style="font-size: 10px;color: red; cursor:pointer;" @click="openvariant(row,index)" v-if="row.novariant==true">Variant &emsp; <small style="font-size:  10px;color: darkblue; cursor:pointer;"> {{row.variantrow}}</small> </small>
                    </td>
                    <td>
                      <input class="form-control-sm" type="text" autocomplete="off"  v-model="row.unit" disabled style="width: 100%;">
                    </td>
                    <td>
                      <input type="text" class="form-control-sm" autocomplete="off"  v-model="row.qty" style="width: 100%;" v-on:change="price(index);">
                      <small style="font-size: 10px; color: red;" v-if="row.err_qty!=''">{{row.err_qty}}</small>
                    </td> 
                    <td>
                      <input type="text" style="width: 100%;" autocomplete="off"  v-model="row.price" class="form-control-sm"  v-on:change="price(index);">
                      <small style="font-size: 10px; color: red;" v-if="row.err_price!=''">{{row.err_price}}</small>
                    </td>
                    <td>
                      <input type="text" style="width: 100%;" autocomplete="off"  v-model="row.salepricemd1" class="form-control-sm">
                      <small style="font-size: 10px; color: red;" v-if="row.err_saleprice!=''">{{row.err_saleprice}}</small>
                    </td>
                    <td>
                      <input type="text" style="width: 100%;" autocomplete="off"  class="form-control-sm" v-model="row.amt" disabled="">
                    </td>
                    <td v-if="is_cs_gst">
                      <input type="text" style="width: 100%;" autocomplete="off"  class="form-control-sm" v-model="row.sgst" v-on:change="price(index);">
                      <small style="font-size: 10px; color: red;" v-if="row.err_sgst!=''">{{row.err_sgst}}<br></small>
                    </td>  
                    <td v-if="is_cs_gst">
                      <input type="text" style="width: 100%;" autocomplete="off"  class="form-control-sm" v-model="row.cgst" v-on:change="price(index);" >
                      <small style="font-size: 10px; color: red;" v-if="row.err_cgst!=''">{{row.err_cgst}}<br></small>
                    </td>
                    <td v-if="is_i_gst">
                      <input type="text" style="width: 100%;" autocomplete="off"  class="form-control-sm" v-model="row.igst" v-on:change="price(index);">
                      <small style="font-size: 10px; color: red;" v-if="row.err_igst!=''">{{row.err_igst}}<br></small>
                    </td>
                    <td>
                      <input type="text" disabled="disabled" autocomplete="off"  v-model="row.amttotal" style="width: 100%;" class="form-control-sm">
                    </td>
                    <td>
                      <center>
                        <i class='fa fa-bell bell' style="color: red;" v-b-tooltip.hover title="Sale Adjustment" @click="onSelectAdjustment(index,row)" v-if="row.is_adjustment"></i>
                        <i class="fa fa-reorder" style="color: #20a8d8;" v-b-tooltip.hover title="Add More option" variant="secondary" @click="openmodal(index)"></i>
                        <i class="fa fa-trash-o" style="color: #F44336;" v-b-tooltip.hover title="Delete" v-on:click="removeElement(index);"></i></center>
                      </td>
                    </tr>

                    <tr>
                      <td colspan="2">
                        <div style="font-size:  13px; color: green;">Add New Row 
                         <span style="cursor:  pointer;" @click="addRow1" class="badge badge-pill badge-info" v-b-tooltip.hover title="Add New Row">Add</span></div>
                       </td>
                       <td style="text-align: right;" colspan="10">Total Items Discount:
                         <input type="text" class="form-control-sm"  disabled="" :value="totaldis" ></td> 
                       </tr>

                       <tr>
                        <td colspan="2"></td>
                        <td style="text-align: right;" colspan="10">Additional Discount : 
                          <input type="" class="form-control-sm" autocomplete="off"  v-on:change="discountadd" v-model="detail.addition">
                        </td> 
                      </tr>

                      <tr>
                        <td colspan="2"></td>
                        <td style="text-align: right;" colspan="10">Total Amount Before Tax:
                          <input type="" class="form-control-sm" :value="totalamt" disabled="">
                        </td> 
                      </tr>
                      <tr  v-if="is_cs_gst">
                        <td colspan="2"></td>
                        <td style="text-align: right;" colspan="10">SGST: <input type="text" class="form-control-sm" disabled="" :value="totalsgst"></td> 
                      </tr>

                      <tr v-if="is_cs_gst">
                        <td colspan="2"></td>
                        <td style="text-align: right;" colspan="10">CGST:
                         <input type="text"  class="form-control-sm" disabled="" :value="totalcgst">
                       </td> 
                     </tr>
                     
                     <tr  v-if="is_i_gst">
                      <td colspan="2"></td>
                      <td style="text-align: right;" colspan="10">IGST: 
                        <input type="text" class="form-control-sm" disabled="" :value="totaligst">
                      </td> 
                    </tr>
                    <tr>
                      <td colspan="2" style="text-align: left;">Payment Type:</td>
                      <td colspan="2" style="text-align: left;">
                        <b-form-select v-model="selected_pytype" :options="lst_paymenttype" v-on:change="paychange"></b-form-select>
                      </td>
                      <td style="text-align: right;" colspan="8">Total Tax Amount : 
                       <input type="text" :value="totaltax" disabled="" class="form-control-sm">
                     </td> 
                   </tr> 
                   <tr> 
                    <td colspan="4" style="text-align: left;">
                      <b-form-group label="">
                        Payment Mode:
                        <b-form-radio v-model="selected_pymode" name="payment_mode" value="cash" v-on:change="modechange">Cash</b-form-radio>
                        <b-form-radio v-model="selected_pymode" name="payment_mode" value="cheque" v-on:change="modechange">Cheque</b-form-radio>
                      </b-form-group>
                    </td>
                    <td colspan="8" style="text-align: right;">Total Amount To Pay: <input type="text" :value="totalamtpay" disabled="" class="form-control-sm"></td> 
                  </tr> 
                  <tr v-if="fullpay === true">
                    <td colspan="2"></td>
           <!-- <td colspan="10" style="text-align: right;">Amount Paid: <input type="text" v-on:change="calchnge();" class="form-control-sm" v-model="totalamtreceived"><br>
              <small style="font-size: 10px; color: red;" v-if="amt_rec != ''" >{{amt_rec}}</small>
            </td> -->

            <td colspan="10" style="text-align: right;">Amount Paid: <input type="text" disabled class="form-control-sm" :value="totalamtpay"><br>

            </td>

          </tr>
        <!--
        <tr v-if="fullpay === true">
            <td colspan="2"></td>
            <td colspan="10" style="text-align: right;">Change: <input type="text" class="form-control-sm" disabled="" v-model="chng"></td> 
        </tr>
      -->
      <tr v-if="parpay === true">
        <td colspan="2"></td>
        <td colspan="10" style="text-align: right;">Amount Paid: <input type="text" class="form-control-sm" v-model="totalparamtreceived" v-on:change="calbalance();"><br>
          <small style="font-size: 10px; color: red;" v-if="amt_rec != ''" >{{amt_rec}}</small>
        </td> 
      </tr>
      <tr v-if="parpay === true">
        <td colspan="2"></td>
        <td colspan="10" style="text-align: right;">Balance: <input type="text" class="form-control-sm" disabled="" v-model="bal"></td> 
      </tr>
      <tr v-if="chqpay === true">
        <td colspan="2"></td>
        <td colspan="10" style="text-align: right;">Cheque No.: <input type="text" name="cheque_no" autocomplete="off" v-model="cheque_no" class="form-control-sm" placeholder="Enter Cheque No"><br>
          <small style="font-size: 10px; color: red;" v-if="chequeno_validate != ''" >{{chequeno_validate}}</small>
        </td> 
      </tr>
      <tr v-if="chqpay === true">
        <td colspan="2"></td>
        <td colspan="10" style="text-align: right;">Cheque Date.: <date-picker v-model="cheque_date" editable lang="en" class="form-control-sm"></date-picker><br>
          <small style="font-size: 10px; color: red;" v-if="chequedate_validate != ''" >{{chequedate_validate}}</small>
        </td> 
      </tr>
    </tbody>
  </table>
  <b-modal title="Add More Option" no-close-on-esc no-close-on-backdrop v-model="largeModal" class="modal-info"  hide-footer @ok="largeModal = false">
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label for="name">Batch</label>
          <input type="text" class="form-control" autocomplete="off"  name="cmp_phone" v-model="batchmd" placeholder="Enter Batch">
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label for="name">Serial Number </label>
          <input type="text" class="form-control" autocomplete="off"  v-model="serialmd" placeholder="Enter Serial Number">
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label for="name">Discount Percentage</label>
          <input type="text" class="form-control" name="cmp_phone" v-model="percentagemd" autocomplete="off"  placeholder="Enter Discount Percentage"  >
          <small  class="form-text text-muted"  ><strong style="color: red;">{{haserror.dis}}</strong></small>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label for="name">Discount Amount </label>
          <input type="text" class="form-control" autocomplete="off"  v-model="amtmd" placeholder="Enter Discount Amount"  >
          <small  class="form-text text-muted"  ><strong style="color: red;">{{haserror.amt}}</strong></small>
        </div>
      </div>
    </div>

    <div class="row">
                <!-- <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">Sales Price</label>
                    <input type="text" class="form-control" name="sale_price" v-model="salepricemd" autocomplete="off"  placeholder="Enter Sales Price">
                    <small  class="form-text text-muted"  ><strong style="color: red;">{{haserror.saleprice}}</strong></small>
                  </div>
                </div> -->
                <div class="col-sm-12">
                  <div class="form-group"><br>
                    <label for="name">Tax Inclusive</label>
                    <input type="checkbox" name="cmp_inclusive" autocomplete="off"  v-model="inclusive">
                    <small class="form-text text-muted"><strong style="color: red;">{{haserror.inclusive}}</strong></small>
                  </div>
                </div>
              </div>
              <div class="card-footer modal_footer">
                <button type="submit" class="btn btn-sm btn-primary" @click="savemodal(indexval)"><i class="fa fa-dot-circle-o"></i> Save</button>
              </div>
            </b-modal>




            <!-- changes in popup modal -->
            <b-modal title="Select Variant" no-close-on-esc no-close-on-backdrop size="sm"  v-model="smallmodal"  hide-footer @ok="smallmodal = false" @hide="">

              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <model-list-select :list="variantvalue" option-value="variant_value" option-text="variant_value" v-model="variantdata" placeholder="Search Variant Value" @input="onSelectvariant($event)"></model-list-select>
                  </div>
                </div>
              </div>
            </b-modal>
            <!-- end  -->
            <!-- sale Adjustment -->
          </div>
        </div>
        <div class="card-footer">
          <button type="submit" class="btn btn-sm btn-primary" @click="finalsubmit"><i class="fa fa-dot-circle-o"></i> Save</button>
        </div>
      </div>
    </div>
  </div>
  <b-modal class="modal-info" size="lg" title="Sale Adjustment" no-close-on-esc no-close-on-backdrop v-model="Adjustment"  hide-footer @ok="Adjustment">
    <div class="card-body">
      <div class="row">
        <div class="col-sm-12 alert alert-danger" v-if="haserror.message1!=''" style="text-align:center;">{{haserror.message1}}</div>
      </div>                
    </div>
    <vue-good-table @on-select-all="selectAll" @on-row-click="toggleSelectRow"  :columns="columnsadj" :rows="rowsadj" :select-options="{ enabled: true }" :search-options="{ enabled: true }" styleClass="vgt-table striped bordered table-sm condensed"></vue-good-table>
    <div class="card-footer modal_footer"> 
      <button :disabled="disabled == 1 ? true : false" type="submit" class="btn btn-sm btn-primary" @click="save_adjustment()">
        <i class="fa fa-dot-circle-o"></i> Save</button>
      </div>
    </b-modal>
    <b-modal
      title="Plan Limit Reached"
      size="sm"
      class="modal-warning"
      ok-only 
      v-model="plan_modal"
    >
      <b-row>
        <b-col sm="2">
            <i class="fa fa-exclamation" style="font-size:40px;color:red"></i>
          </b-col>
          <b-col sm="10">
            <b-row>
            <b>You have hit the plan limit.</b>
            </b-row>
            <b-row>
              You have reached the limit of adding Supplier. Please upgrade your plan to add more Suppliers.
            </b-row>
          </b-col>
        </b-row>
      </b-modal>

        <b-modal
        title="Plan Limit Reached"
        size="sm"
        class="modal-warning"
        ok-only 
        v-model="shopplan_modal"
      >
      <b-row>
        <b-col sm="2">
            <i class="fa fa-exclamation" style="font-size:40px;color:red"></i>
          </b-col>
          <b-col sm="10">
            <b-row>
            <b>You have hit the plan limit.</b>
            </b-row>
            <b-row>
              You have reached the limit of adding Shops. Please upgrade your plan to add more Shops.
            </b-row>
          </b-col>
        </b-row>
      </b-modal>
    <!-- end sale Adjustment-->
    <Spinner v-if="loading"></Spinner>
  </div>
</template>

<script>
 import Spinner from '../../spinner.vue'
 import DatePicker from 'vue2-datepicker'
 export default {
   components: {
    'date-picker':  DatePicker,
    Spinner
  },
  data () {
    return {
      columnsadj: [
      {
        label: 'Sales ID',
        field: 'sale_id',
        width: '10% !important'
      },
      {
        label: 'Product Name',
        field: 'productname',
        width: '30% !important'
      },
      {
        label: 'Variant',
        field: 'variant',
        width: '15% !important'
      },
      {
        label: 'Qty',
        field: 'qty',
        width: '5% !important'
      },
      {
        label: 'Amount Per Unit',
        field: 'amount',
        width: '20% !important'
      },
      {
        label: 'Date',
        field: 'createdAt',
        type: 'date',
        dateInputFormat: 'YYYY-MM-DD',
        dateOutputFormat: 'MMM Do YY',
        width: '20% !important'
      },
      ],
      disabled: 0,
      amt_rec: '',
      chequeno_validate:'',
      chequedate_validate:'',
      rowsadj: [],
      current_index:null,
      is_cs_gst:true,
      is_i_gst:true,
      Adjustment: false,
      loading:false,
      variantindex:null,
      smallmodal:false,
      plan_modal:false,
      shopplan_modal:false,
      fullpay:true,
      chqpay:false,
      parpay:false,
        // chng:0,
        bal:0,
        totalamtreceived:'',
        totalparamtreceived:'',
        cheque_no:'',
        cheque_date:'',
        variantvalue:[],
        selected_pytype:'full',
        lst_paymenttype:[
        { value: 'full', text: 'Full' },
        { value: 'partial', text: 'Partial' },
        { value: 'no', text: 'No' },
        ],
        selected_pymode:'cash',
        selectedcustomer:null,
        company_gst:'',
        supplier_gst:'',
        variantdata:null,
        batchmd:'',
        serialmd:'',
        percentagemd:'',
        amtmd:'',
        salepricemd:0,
        inclusive:false,
        indexval:null,
        largeModal:false,
        suppliername:[],
        prod_lst:[],
        barcodelist:[],
        barcode:'',
        shopname:[],
        selectshop:null,
        rows:[],
        // lst_prod_var:[],
        haserror:{
          amt:'',
          dis:'',
          cust:'',
          message:'',
          message1:'',
          inclusive:'',
          saleprice:'',
          shop:'',
        },
        detail:{
          totprddis:'',
          addition:'',
          tot:'',
          cgst:'',
          sgst:'',
          igst:'',
          taxamt:'',
          totalamtpay:'',
        }
      }
    },

    computed: {
      sup_rights: function(){
        return this.$store.getters.get_sup_rights
      },
      totaldis() {
        var all =this.rows.reduce((total,row) => {
          if(Number(row.amtmd1)==0){
            return total +  (Number(row.qty)*Number(row.price)*Number(row.percentagemd1))/100;
          }else{
            return total +  (Number(row.amtmd1));
          }
        }, 0);
        all = all.toFixed(4);
        this.detail.totprddis=all;
        return all;
      },
      totalamt() {
        var all =this.rows.reduce((total,row) => {
          return total +  Number(row.amt);
        }, 0);
        all = all.toFixed(4);
        this.detail.tot=all;
        return all;
      },
      totalcgst() {
        var all =this.rows.reduce((total,row) => {
          return total +  ((Number(row.cgst)*Number(row.amt))/100);
        }, 0);
        all = all.toFixed(4);
        this.detail.cgst=all;
        return all;
      },
      totalsgst() {
        var all =this.rows.reduce((total,row) => {
          return total +  ((Number(row.sgst)*Number(row.amt))/100);
        }, 0);
        all = all.toFixed(4);
        this.detail.sgst=all;
        return all;
      },
      totaligst() {
        var all =this.rows.reduce((total,row) => {
          return total +  ((Number(row.igst)*Number(row.amt))/100);
        }, 0);
        all = all.toFixed(4);
        this.detail.igst=all;
        return all;
      },
      totaltax() {
        var all =this.rows.reduce((total,row) => {
          return total +  (Number(row.amttotal)-Number(row.amt));
        }, 0);
        all = all.toFixed(4);
        this.detail.taxamt=all;
        return all;
      },
      totalamtpay(){
        var all =this.rows.reduce((total,row) => {
          return total +  (Number(row.amttotal));
        }, 0);
        all = all.toFixed(4);
        if(this.detail.addition==''){
          this.detail.totalamtpay=all;
          return all
        }else{
          this.detail.totalamtpay=all-parseFloat(this.detail.addition);
          this.totalamtreceived=all-parseFloat(this.detail.addition);
          return all-parseFloat(this.detail.addition);
        }
      }

    },

    created(){
      for (var i = 0; i <3; i++) {
        this.rows.push({ productnamex:[],selectedproductid:'',unit:'',unitvalue:'',selectproductrow:null,price:'', qty:'',amt:'', cgst:0, sgst:0,igst:'',amttotal:0,batchmd1:'',serialmd1:'',percentagemd1:'', amtmd1:'',variantrow:'n/a', inclusive1:false, salepricemd1:'', err_saleprice:'', is_adjustment:false, adjustment_list:[], adjusted:[], err_qty:'', err_price:'', err_sgst:'', err_cgst:'', err_igst:'',showvariant:false,novariant:false,productExist:''})
      }
      this.searchshops();
      this.searchsupplier();
      
      // this.listproduct();
      this.shopuser();

    },

    methods:{

      // calchnge(){
      //   var regexp = /^[1-9]\d*(\.\d+)?$/
      //   if(this.totalamtreceived !== ''){
      //     if(regexp.test(this.totalamtreceived) === false){
      //       alert('Please Enter Valid Amount')
      //       this.totalamtreceived = ''
      //       return
      //     }else{
      //       this.chng = (parseFloat(this.totalamtreceived) - parseFloat(this.detail.totalamtpay)).toFixed(2)
      //     }
      //   }
      // },

      addSupplier(){
        var _thiss = this
        this.loading = true;
        this.$http.get('/api/suppliers/chk_plan_count').then(function(response){
          _thiss.loading = false;
          if('message' in response.data){
            if(response.data.message === true){
              _thiss.plan_modal = true
            }
            else{
              _thiss.plan_modal = false
              var params = {}
              var _this = _thiss
              _thiss.$http.get('/api/countries').then(function(countries){
                params["conopt"] = countries.data;
                var __this = _this
                _this.$http.get('/api/companytypes').then(function(response){
                  params["contyp"] = response.data;
                  __this.$addsuppliermodal.showSupplier(params);
                  var ___this = __this
                  var timer = setInterval(function(){
                  var modal_return = ___this.$store.getters.get_supmodal;
                  if(modal_return !== null){
                        // __this.selectshop = modal_return  
                        // ___this.searchsupplier(modal_return)
                        ___this.suppliername.push(modal_return)
                        ___this.selectedcustomer = modal_return
                        clearInterval(timer);
                      }
                    }, 1000);
                }).catch(function(err){
                  console.log(err)
                })
                
              }).catch(function(error){
                console.log(error)
              })
			      }
          }
          else{
            console.log('something went wrong')
          }
          }).catch(function(error){
            console.log(error)
          });
        
      },
      addProduct(row,index) {
        var _thiss = this
        this.loading = true;
        this.$http.get('/api/companyproducts/chk_plan_count').then(function(response){
          _thiss.loading = false;
          if('message' in response.data){
            if(response.data.message === true){
              _thiss.plan_modal = true
            }
            else{
              _thiss.plan_modal=false
              if(_thiss.selectedcustomer==null || _thiss.selectedcustomer.supplier_id === undefined){
                _thiss.haserror.cust="Please Select Supplier"
              }
              else{
                _thiss.haserror.cust = ""
                var _this = _thiss
                _thiss.$http.get('/api/companyproducts/loadData').then(function (response){
                  if(response.data.data){
                    _this.$addproductmodal.show(response.data.data);
                    var __this = _this
                    var timer = setInterval(function(){
                    var modal_return = __this.$store.getters.get_productmodal;
                    if(modal_return !== null){
                      row.productnamex.push(modal_return)
                      row.selectproductrow = modal_return
                      __this.openvariant(row,index)
                      clearInterval(timer);
                    }
                    }, 1000);
                  }
                }).catch(function(error){
                  if (error.response.status === 401) {
                    localStorage.clear();
                    _this.$store.commit('SET_AUTH_USER', null)
                    _this.$router.push('/');
                  }
                  if(error.response.data.error.message === "Cannot read property 'cmpname' of null"){
                    localStorage.clear();
                    _this.$store.commit('SET_AUTH_USER', null)
                    _this.$router.push('/');
                  }
                });
              }
            }
          }
          else{
            console.log('something went wrong')
          }
          }).catch(function(error){
            console.log(error)
          });
    },
    
    addShop(){
      var _thiss=this
      _thiss.loading = true;
        _thiss.$http.get('/api/shopestablishments/chk_plan_count').then(function(response){
          // console.log(response.data.message)
          _thiss.loading = false;
          if('message' in response.data){
            if(response.data.message === true){
              _thiss.plan_modal = true
            }
            else{
              var params = {}
              _thiss.$http.get('/api/countries').then(function(countries){
                params['countries'] = countries.data
                var __this = _thiss
                _this.$http.get('/api/users/allusers').then(function(alluser){
                  params['alluser'] = alluser.data
                  __this.$addshopmodal.showShop(params);
                  var ___this = __this
                  var timer = setInterval(function(){
                  var modal_return = ___this.$store.getters.get_shopmodal;
                  if(modal_return !== null){
                          // __this.selectshop = modal_return  
                          ___this.searchshops(modal_return)
                          clearInterval(timer);
                        }
                      }, 1000);
                }).catch(function(error){
                  console.log("error - " + error)
                })
              }).catch(function(error){
                console.log("error - " + error)
              })
			      }
          }
          else{
            console.log('something went wrong')
          }
          }).catch(function(error){
            console.log(error)
          });
    },
    calbalance(){
      var regexp = /^[1-9]\d*(\.\d+)?$/
      if(this.totalparamtreceived !== ''){
        if(regexp.test(this.totalparamtreceived) === false){
          alert('Please Enter Valid Amount')
          this.totalparamtreceived = ''   
          return
        }else{
          this.bal = (parseFloat(this.detail.totalamtpay) - parseFloat(this.totalparamtreceived)).toFixed(4)
        }
      }
    },

    paychange(select_paytype_val){
      this.selected_pytype = select_paytype_val
      this.fullpay = false
      this.parpay = false
      if(this.selected_pytype === 'full'){
        this.fullpay = true
        if(this.selected_pymode == 'cheque'){
          this.chqpay = true
        }
        else{
          this.chqpay = false
        }
      }
      else if(this.selected_pytype === 'partial'){
        this.parpay = true
        if(this.selected_pymode == 'cheque'){
          this.chqpay = true
        }
        else{
          this.chqpay = false
        }
      }
      else{
        this.chqpay = false
      }
    },

    modechange(select_paymode_val){
      this.selected_pymode = select_paymode_val
      if(this.selected_pytype !== 'no'){
        if(this.selected_pymode == 'cheque'){
          this.chqpay = true
        }
        else{
         this.chqpay = false
       }
     }
     else{
      this.chqpay = false
    }
  },

  checkVariant(index){
    if(this.variantdata == null){
      this.rows[index].adjustment_list=[]
      this.rows[index].adjusted=[]
          // this.rows[index].productnamex=[]
          this.rows[index].selectedproductid=null
          this.rows[index].unit=''
          this.rows[index].selectproductrow=null
          this.rows[index].price=''
          this.rows[index].qty=''
          this.rows[index].amt=''
          this.rows[index].cgst=0
          this.rows[index].sgst=0
          this.rows[index].igst=''
          this.rows[index].batchmd1=''
          this.rows[index].serialmd1=''
          this.rows[index].is_adjustment=false
          this.rows[index].amttotal=0
          this.rows[index].percentagemd1=''
          this.rows[index].amtmd1=''
          this.rows[index].variantrow='n/a'
          this.rows[index].unitvalue=''
          this.rows[index].novariant=false
          this.rows[index].showvariant=false
          this.rows[index].inclusive1=false
          this.rows[index].err_qty=''
          this.rows[index].err_price=''
          this.rows[index].err_sgst=''
          this.rows[index].err_cgst=''
          this.rows[index].err_igst=''
          this.rows[index].productExist=''
        }

        
      },
      checkShop(){
        if(!this.selectedcustomer)
        {
          this.haserror.cust="Select Supplier"
          this.barcode=''
        }else{this.haserror.cust=''}

        if(!this.selectshop)
        {
          this.haserror.shop="Select Shop"
          this.barcode=''
        }else{this.haserror.shop=''}
      },

      searchBarcode(){
        var _this = this 
        
        var option = []
        var index = 0
        var addRow = 0
        var barcode = this.barcode
        
        this.checkShop()

        this.barcode = ''
        if(barcode){

          this.$http.get('/api/purchasereturns/joinproduct2?barcode='+barcode).then(function (response) {


            var valueArr = _this.rows.map(item => item)
            var rowindex = -1
            var check =  valueArr.some(function(value,indx){

              if(value.selectproductrow == null){
                rowindex = indx
                
                return true }else {return false}
              })
            if(response.data[0] != null){

              if(_this.rows.length == 0 || rowindex == -1){
                rowindex = rowindex != -1 ? rowindex : _this.rows.length
                _this.rows.push({ productnamex:[],selectedproductid:'',unit:'',unitvalue:'',selectproductrow:null,price:'', qty:'',amt:'', cgst:0, sgst:0,igst:'',amttotal:0,batchmd1:'',serialmd1:'',percentagemd1:'', amtmd1:'',variantrow:'n/a', inclusive1:false, salepricemd1:'', err_saleprice:'', is_adjustment:false, adjustment_list:[], adjusted:[], err_qty:'', err_price:'', err_sgst:'', err_cgst:'', err_igst:'',showvariant:false,novariant:false,productExist:''})
              }
              _this.rows[rowindex].productnamex.push(response.data[0])
              _this.rows[rowindex].selectproductrow=response.data[0]
              _this.openvariant(response.data[0],rowindex)
            }  
            
            
          }).catch(function(error){console.log('error')})
        }else{}
      },


      nameAndnumber (item) {
        return `${item.sup_cmp_name} - ${item.sup_cmp_phone}`
      },

      shopuser(){
        var _this=this
        this.$http.get('/api/shopusers').then(function(response){

        }).catch(function(error){
          if (error.response.status === 401) {
            localStorage.clear();
            _this.$store.commit('SET_AUTH_USER', null)
            _this.$router.push('/');
          }
          if(error.response.data.error.message === "Cannot read property 'cmpname' of null"){
            localStorage.clear();
            _this.$store.commit('SET_AUTH_USER', null)
            _this.$router.push('/');
          }
        })
      },
      onSelectAdjustment(index,row){
        this.current_index = null
        this.current_index = index
        this.haserror.message1 = ''
        this.disabled = 0
        this.Adjustment = true
        this.rowsadj = []

        for (var i = 0; i < row.adjustment_list.length; i++) {
          if(row.adjusted.length > 0){
            var vgtSelected = false
            for (var j = 0; j < row.adjusted.length; j++) {
              if(row.adjusted[j] == row.adjustment_list[i].saleadjustment_id){
                var vgtSelected = true
              }
            }
            this.rowsadj.push({sale_id:row.adjustment_list[i].saleadjustment_id, productname : row.adjustment_list[i].product_id, variant: row.adjustment_list[i].variant_id, qty: row.adjustment_list[i].adjusted_qty, amount: row.adjustment_list[i].sale_amount, createdAt: row.adjustment_list[i].lastupdated_datetime,vgtSelected:vgtSelected})
          }else{
            this.rowsadj.push({sale_id:row.adjustment_list[i].saleadjustment_id, productname : row.adjustment_list[i].product_id, variant: row.adjustment_list[i].variant_id, qty: row.adjustment_list[i].adjusted_qty, amount: row.adjustment_list[i].sale_amount, createdAt: row.adjustment_list[i].lastupdated_datetime,vgtSelected:false})
          }
        }
        this.checking_adjustment()
      },

      save_adjustment() {
        this.rows[this.current_index].adjusted = []
        for (var i = 0; i < this.rowsadj.length; i++) {
          if(this.rowsadj[i]['vgtSelected'] == true){
            this.rows[this.current_index].adjusted.push(this.rowsadj[i]['sale_id'])
          }
        }
        this.Adjustment = false
      },

      selectAll(selected, selectedRows) {
        if(selected.selectedRows.length === 0){
          var vgtSelected = false
        }else{
          var vgtSelected = true
        }

        for (var i = 0; i < this.rowsadj.length; i++) {
          this.rowsadj[i]['vgtSelected'] = vgtSelected
        }
        this.checking_adjustment()
      },

      toggleSelectRow(params) {
        this.rowsadj[params.row.originalIndex]['vgtSelected'] = params.row.vgtSelected
        this.checking_adjustment()
      },

      checking_adjustment(){
        var row_qty = this.rows[this.current_index]['qty']
        var adj_qty = 0
        for (var i = 0; i < this.rowsadj.length; i++) {
          if (this.rowsadj[i].vgtSelected){
            adj_qty += parseFloat(this.rowsadj[i].qty)
          }
        }
        if(adj_qty > row_qty){
          this.disabled = 1
          this.haserror.message1 = 'Adjustment Quantity Cannot Be Greater Than Purchase Quantity'
        }else{
          this.disabled = 0
          this.haserror.message1 = ''
        }
      },

      company_data(){
        // console.log(this.selectshop)
        this.company_gst = this.selectshop.shop_gst
        
        // console.log(this.company_gst)
      },

      onSelectShp(option){
        this.selectshop = option
        // console.log(this.saleprice_editable)
        this.haserror.shop=''
        this.company_data();
        if(this.selectedcustomer !== null && this.selectedcustomer !== undefined)
          this.onSelectSup(this.selectedcustomer);
        if(option.id != undefined){
          if(this.selectshop==null || this.selectshop.est_shop_id === undefined){
            this.haserror.shop="Please Select Shop"
          } 
        }else{
          this.haserror.shop="Please Select Shop"
        }
        if(this.rows.length > 0){
          for (var i = 0; i < this.rows.length; i++) {
            if(this.rows[i].selectproductrow != null){
              this.sale_adjustment(this.rows[i].selectproductrow,i)
            }
          }
        }
      },

      onSelectSup(option){
        this.is_cs_gst = true
        this.is_i_gst = true

        if(option.sup_cmp_gst !== undefined){
          this.haserror.cust=''
          this.supplier_gst=option.sup_cmp_gst
        }
        if(this.company_gst && this.supplier_gst){

          var company_gst = this.company_gst.substring(0, 2)
          var supplier_gst = this.supplier_gst.substring(0, 2)
          if(company_gst === supplier_gst){

            this.is_cs_gst = true
            this.is_i_gst = false
          }else{

            this.is_cs_gst = false
            this.is_i_gst = true
          }
        }
        else if(this.supplier_gst === null || this.supplier_gst === ''){

          this.is_cs_gst = false
          this.is_i_gst = false
        }
        else{

          this.is_cs_gst = true
          this.is_i_gst = true
        }

        if(this.rows.length > 0){
          for (var i = 0; i < this.rows.length; i++) {
            if(this.rows[i].selectproductrow != null){
              this.show_tax(this.rows[i].selectproductrow,i)
            }
          }
        }
      },

      onSelectvariant(option){
        if(option.variant_value === 'No Variant') {
          this.rows[this.variantindex]['variantrow']='n/a'
        }
        else{
          this.rows[this.variantindex]['variantrow']=option.variant_value
        }
        this.smallmodal=false; 
        // var curr_prod = this.rows[this.variantindex]['selectproductrow']['product_id']
        // var curr_var = this.rows[this.variantindex]['variantrow']
        
        // if(this.lst_prod_var.length > 0){
        //   if(this.lst_prod_var.indexOf(curr_prod+'_'+curr_var) !== -1){
        //     alert('Item - ' + this.rows[this.variantindex]['selectproductrow']['product_name'] + ' with variant ' + option.variant_value + ' already added above. Kindly select other product')
        //       this.rows[this.variantindex]['selectproductrow']=null;
        //       this.rows[this.variantindex]['variantrow']=null
        //       return
        //   }
        // }
        // this.lst_prod_var[this.variantindex] = curr_prod+'_'+curr_var
        // var index = this.variantindex
        // var _this = this
        // var row = this.rows[this.variantindex]
        var row = this.rows[this.variantindex].selectproductrow
        this.sale_adjustment(row,this.variantindex)
        this.onSelect(row,this.variantindex)
      },


      openvariant_on_product(row, index){
        if('product_id' in row.selectproductrow){
          this.openvariant(row,index)
        }
        else{
          return false
        }
      },
      openvariant(row,index){ 
        this.variantindex=index
        this.variantdata=null
        this.variantvalue=[]
        var _this = this
        
        var vrnt_id = row.selectproductrow == null ? row.variant_id : row.selectproductrow.variant_id
        
        if(vrnt_id!=null){
          this.rows[this.variantindex].novariant = true
          this.rows[this.variantindex].showvariant = false
          this.smallmodal=true;

          this.$http.get('/api/variantvalues?filter[where][variant_id]='+vrnt_id).then(function (response){
            _this.variantvalue=response.data
            _this.variantvalue.unshift({company_id: "I2OCGLB", id: 0, regcity_code: "I2O", variant_id: "0", variant_value: "No Variant"})
          }).catch(function (error) {

          });
        }else{
          this.rows[this.variantindex].novariant = true
          this.rows[this.variantindex].showvariant = false
          var option = {company_id: "I2OCGLB", id: 0, regcity_code: "I2O", variant_id: "0", variant_value: "No Variant"}
          this.onSelectvariant(option)
          this.smallmodal=false;
        }
      },

      sale_adjustment(option,index){
        var _this = this
        this.$http.get('/api/salesadjustments?filter[where][est_shop_id]='+_this.selectshop.est_shop_id+'&filter[where][product_id]='+option.product_id+'&filter[where][variant_id]='+_this.rows[index]['variantrow']).then(function (response){
          if(response.data.length>0){
            _this.rows[index]['adjustment_list'] = response.data
            _this.rows[index]['is_adjustment'] = true
          }else{
            _this.rows[index]['adjustment_list'] = []
            _this.rows[index]['is_adjustment'] = false
            _this.rows[index]['adjusted'] = []
          }
        }).catch(function (error) {

        });
        this.onSelect(option,index)
      },

      

      show_tax(option,index){
        var _this = this
        this.$http.get('/api/taxrates/findOne?filter[where][tax_id]='+option.tax_gst_id).then(function (response){
          if(_this.company_gst && _this.supplier_gst){
            var company_gst = _this.company_gst.substring(0, 2)
            var supplier_gst = _this.supplier_gst.substring(0, 2)
            // _this.rows[index]['inclusive1'] = false
            if(company_gst === supplier_gst){
              _this.rows[index]['cgst'] = response.data.tax_cgst
              _this.rows[index]['sgst'] = response.data.tax_sgst
              _this.rows[index]['igst'] = 0.00
            }else{
              _this.rows[index]['cgst'] = 0.00
              _this.rows[index]['sgst'] = 0.00
              _this.rows[index]['igst'] = response.data.tax_igst
            }
            _this.price(index)
          }else if(_this.supplier_gst === null || _this.supplier_gst === ''){
            // _this.rows[index]['inclusive1'] = true
            _this.rows[index]['cgst'] = 0.00
            _this.rows[index]['sgst'] = 0.00
            _this.rows[index]['igst'] = 0.00
            _this.price(index)                
          }else{
                // Enable to edit
                // _this.rows[index]['inclusive1'] = false
                _this.rows[index]['cgst'] = response.data.tax_cgst
                _this.rows[index]['sgst'] = response.data.tax_sgst
                _this.rows[index]['igst'] = 0.00
                _this.price(index)
              }
            });
      },
      onSelect(option,index){
        var _this = this
        _this.rows[index]['inclusive1'] = false
        _this.current_index = null
        if(option != null){
          if(option.alt_product_id !== undefined){
            _this.show_tax(option,index)
            
            _this.rows[index]['qty']=1
            _this.rows[index]['unit']=option.unit_name
            _this.rows[index]['unitvalue']=option.unit_id
            // _this.rows[index]['selectedproductid']=option.variant_id
            // _this.rows[index]['variantrow']='n/a'
            _this.rows[index]['adjustment_list']=[]
            _this.rows[index]['adjusted']=[]
            _this.rows[index]['price']=''
          }else{
            _this.rows[index]['selectedproductid']=''
            _this.rows[index]['unit']=''
            _this.rows[index]['unitvalue']=''
            _this.rows[index]['selectproductrow']=null
            _this.rows[index]['price']=''
            _this.rows[index]['qty']=''
            _this.rows[index]['amt']=''
            _this.rows[index]['cgst']=0
            _this.rows[index]['sgst']=0
            _this.rows[index]['igst']=''
            _this.rows[index]['amttotal']=0
            _this.rows[index]['batchmd1']=''
            _this.rows[index]['serialmd1']=''
            _this.rows[index]['percentagemd1']=''
            _this.rows[index]['amtmd1']=''
            _this.rows[index]['variantrow']='n/a'
            _this.rows[index]['inclusive1']=false
            _this.rows[index]['salepricemd1']=0
            _this.rows[index]['adjustment_list']=[]
            _this.rows[index]['adjusted']=[]
            _this.rows[index].showvariant = false
            _this.rows[index].novariant = false
          }
        }else{
          _this.rows[index]['selectedproductid']=''
          _this.rows[index]['unit']=''
          _this.rows[index]['unitvalue']=''
          _this.rows[index]['selectproductrow']=null
          _this.rows[index]['price']=''
          _this.rows[index]['qty']=''
          _this.rows[index]['amt']=''
          _this.rows[index]['cgst']=0
          _this.rows[index]['sgst']=0
          _this.rows[index]['igst']=''
          _this.rows[index]['amttotal']=0
          _this.rows[index]['batchmd1']=''
          _this.rows[index]['serialmd1']=''
          _this.rows[index]['percentagemd1']=''
          _this.rows[index]['amtmd1']=''
          _this.rows[index]['variantrow']='n/a'
          _this.rows[index]['inclusive1']=false
          _this.rows[index]['salepricemd1']=0
          _this.rows[index]['adjustment_list']=[]
          _this.rows[index]['adjusted']=[]
        }

        // _this.sale_adjustment(option,index)
      },

      openmodal(test){
        this.largeModal=true
        this.indexval=test
        this.batchmd='';
        this.serialmd='';
        this.percentagemd='';
        this.amtmd='';
        this.salepricemd='';
        if(this.rows[test]['percentagemd1']!=''){
          this.percentagemd=this.rows[test].percentagemd1;
        }
        if(this.rows[test].amtmd1!=''){
          this.amtmd=this.rows[test].amtmd1;
        }
        this.inclusive=this.rows[test].inclusive1;
        this.salepricemd=this.rows[test].salepricemd1;
      },

      addRow1(){
        this.rows.push({ productnamex:[],selectedproductid:'',unit:'',unitvalue:'',selectproductrow:null,price:'', qty:'',amt:'', cgst:0, sgst:0,igst:'',amttotal:0,batchmd1:'',serialmd1:'',percentagemd1:'', amtmd1:'', variantrow:'n/a', inclusive1:false, salepricemd1:'', err_saleprice:'', is_adjustment:false, adjustment_list:[], adjusted:[], err_qty:'', err_price:'', err_sgst:'', err_cgst:'', err_igst:'',showvariant:false,novariant:false,productExist:''})
      },
      
      removeElement: function(index) {
        this.rows.splice(index, 1);
        if(this.selected_pytype === 'partial'){
           this.bal = 0.0000
           this.totalparamtreceived = ''
         }
      },

      searchshops(shop_id){
       var _this = this
       this.$http.get('/api/shopusers/getShop').then(function (response){
         _this.shopname=response.data
         if(shop_id !== undefined){
           var select_shp = _this.shopname.filter(function(each){
             return each.est_shop_id === shop_id
           });
           _this.selectshop = select_shp[0]
           _this.company_data();
         }
         else{
           var len = response.data.length - 1
           _this.selectshop = response.data[len]
           _this.company_data();
         }
         
       }).catch(function (error) {
         console.log(error);  
       });
     },
      // listproduct(){
      //   var _this = this
      //     this.$http.get('/api/companyproducts').then(function (response){
      //     _this.prod_lst=response.data
      //   }).catch(function (error) {
      //     console.log("error.response");
      //   });
      // },

      searchprd3(searchText,index,row){
        this.haserror.cust=''
        this.haserror.shop=''
        var status = 1
        if(this.selectedcustomer==null || this.selectedcustomer.supplier_id === undefined){
          status = 0
          this.haserror.cust="Please Select Supplier"
        }
        if(this.selectshop==null || this.selectshop.est_shop_id === undefined){
          status = 0
          this.haserror.shop="Please Select Shop"
        }

        if(status == 1){
          var _this = this
          if(searchText){
            this.$http.get('/api/purchasereturns/joinproduct2?data='+searchText).then(function (response) {
            // checkVariant(index)
            row.productnamex=response.data
            
          }).catch(function (error) {
            console.log(error);  
          });}
        }
      },

      searchsupplier(){
        var _this=this                     
        this.$http.get('/api/suppliers').then(function (response) {
          _this.suppliername=response.data
        }).catch(function (error) {
          console.log(error);  
        });
      },

      savemodal(val){
         // var num=/^[0-9]{1,3}$/
         var num=/^([0-9]{1,2}|100)$/
         var num1=/^[0-9]{1,12}$/
         var amt_reg = /^[0-9]\d{0,11}(\.\d{1,6})??$/
         this.haserror.amt=''
         this.haserror.dis=''
         if(this.percentagemd!='' && this.amtmd!=''){
          this.haserror.amt="Please Select Any One"
        }
        else if(this.percentagemd!='' &&  num.test(this.percentagemd)==false){
          this.haserror.dis="Please Provide Integer Between 1-100"                   
        }
        else if(this.amtmd!='' && amt_reg.test(this.amtmd)==false){                                                  
          this.haserror.amt="Please Provide Valid Amount"                      
        }
        else if(parseFloat(this.amtmd)>parseFloat(this.rows[val]['amt'])){
          this.haserror.amt="Discount Amount Cannot Be Greater Than Provided Amount"  
        }
        else{
          this.rows[val]['batchmd1']=this.batchmd
          this.rows[val]['serialmd1']=this.serialmd
          this.rows[val]['percentagemd1']=this.percentagemd
          this.rows[val]['amtmd1']=this.amtmd
          this.rows[val]['inclusive1']=this.inclusive
          this.rows[val]['salepricemd1']=this.salepricemd
          this.largeModal=false;
          this.price(val);
        }
      },

      discountadd(){
        // var num=/^[0-9]{1,11}$/
        var num=/^\d{1,12}(\.\d{1,6})?$/
        if(num.test(this.detail.addition)==false && this.detail.addition!=='' ){
          this.detail.addition='';
          alert("Please Provide Valid Integer For Additional Discount");
        }
        if(parseFloat(this.detail.totalamtpay)<0){
          this.detail.addition='';
          alert("Invalid Entry" )
        }
        if(this.selected_pytype === 'partial'){
             if(this.totalparamtreceived !== ''){
               this.bal = (parseFloat(this.totalamtpay) - parseFloat(this.totalparamtreceived)).toFixed(4)
             }
           }
      },

      price(index){    

        var num=/^[0-9]{1,11}$/
        var price = /^\d{1,12}(\.\d{1,6})?$/
        var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/ 
        var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/

        if(igstexp.test(this.rows[index]['igst'])==false && this.rows[index]['igst']!=''){
          this.rows[index]['igst']=''
          this.rows[index]['err_igst'] = 'Invalid';
        }else if(parseFloat(this.rows[index]['igst'])<0){
          this.rows[index]['igst']=''
          this.rows[index]['err_igst'] = 'Invalid';
        }else{
          this.rows[index]['err_igst'] = '';
        }

        if(tax.test(this.rows[index]['cgst'])==false  && this.rows[index]['cgst']!=0 ){
          this.rows[index]['cgst']=0
          this.rows[index]['err_cgst'] = 'Invalid';
        }else if(parseFloat(this.rows[index]['cgst'])<0){
          this.rows[index]['cgst']=0
          this.rows[index]['err_cgst'] = 'Invalid';
        }else{
          this.rows[index]['err_cgst'] = '';          
        }


        if(tax.test(this.rows[index]['sgst'])==false  && this.rows[index]['sgst']!=0){
          this.rows[index]['sgst']=0
          this.rows[index]['err_sgst'] = 'Invalid';
        }else if(parseFloat(this.rows[index]['sgst'])<0){
          this.rows[index]['sgst']=0
          this.rows[index]['err_sgst'] = 'Invalid';
        }else{
          this.rows[index]['err_sgst'] = '';
        }

        if(this.rows[index]['price']==''){
          this.rows[index]['err_price'] = 'Required';
        }else if(parseFloat(this.rows[index]['price'])<=0.00){
          this.rows[index]['err_price'] = 'Invalid Price';
        }else if(price.test(this.rows[index]['price'])==false  && this.rows[index]['price']!=''){
          this.rows[index]['err_price'] = 'Invalid Price';
        }else{
          this.rows[index]['err_price'] = '';
          this.rows[index]['price'] = parseFloat(this.rows[index]['price']).toFixed(4)
        }

        if(this.rows[index]['qty']==''){
          this.rows[index]['err_qty'] = 'Required';
        }else if(parseFloat(this.rows[index]['qty'])<=0.00){
          this.rows[index]['err_qty'] = 'Invalid Quantity';
        }else if(price.test(this.rows[index]['qty'])==false  && this.rows[index]['qty']!=''){
          this.rows[index]['err_qty'] = 'Invalid Quantity';
        }else{
          this.rows[index]['err_qty'] = '';
        }

        if(this.rows[index]['igst']!=''){
          this.rows[index]['cgst'] = 0
          this.rows[index]['sgst'] = 0
          var igst_value = parseFloat(this.rows[index]['igst'])
        }
        else{
          this.rows[index]['igst']=''
          var igst_value = 0
        }
        
        if(this.rows[index]['qty']!='' && this.rows[index]['price']!=''){
          var qty = parseFloat(this.rows[index]['qty'])
          var price = parseFloat(this.rows[index]['price'])
          var total = qty*price;
        }else if(this.rows[index]['qty']=='' && this.rows[index]['price']==''){
          var qty = 0
          var price = 0
          var total = qty*price;
        }else if(this.rows[index]['qty']!='' && this.rows[index]['price']==''){
          var qty = parseFloat(this.rows[index]['qty'])
          var price = 0
          var total = qty*price;
        }else if(this.rows[index]['qty']=='' && this.rows[index]['price']!=''){
          var qty = 0
          var price = parseFloat(this.rows[index]['price'])
          var total = qty*price;
        }

        if(this.rows[index]['percentagemd1']!=''){
          total=total-(total*this.rows[index]['percentagemd1'])/100
        }
        if(this.rows[index]['amtmd1']!=''){
          total=total-parseFloat(this.rows[index]['amtmd1'])
        }
        
        if(total!=undefined){
          if(this.rows[index]['inclusive1'] == false){
            this.rows[index]['amt']=total.toFixed(4);
            var amttotal=total+(this.rows[index]['sgst']*total)/100 + (this.rows[index]['cgst']*total)/100 + (igst_value*total)/100
            amttotal = amttotal.toFixed(4);
            this.rows[index]['amttotal']=amttotal
          }else if(this.rows[index]['inclusive1'] == true){
            amttotal = total.toFixed(4);
            this.rows[index]['amttotal']=amttotal
            var total_percentage = parseFloat(this.rows[index]['sgst']) + parseFloat(this.rows[index]['cgst']) + igst_value
            var bfttotal = (total * (100/(100 + total_percentage)))
            this.rows[index]['amt']=bfttotal.toFixed(4);
          }
        }

        if(this.selected_pytype === 'partial'){
          this.bal = (parseFloat(this.totalamtpay) - parseFloat(this.totalparamtreceived)).toFixed(4)
        }
        else if(this.selected_pytype === 'full'){
          this.totalamtreceived = parseFloat(this.totalamtpay).toFixed(4)
        }
      },
      

      finalsubmit(){
        this.haserror.message=''
        this.haserror.cust='';
        this.haserror.shop='';
        var submit = 0
        var num=/^[0-9]{1,11}$/
        var price = /^\d{1,12}(\.\d{1,6})?$/
        var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/
        var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/
        
        for (var i = this.rows.length-1; i >=0;  i--) {

          if(this.rows[i].selectproductrow!=null){

            if(this.rows[i].price==''){
              submit = 1
              this.rows[i].err_price = 'Required';
            }else if(parseFloat(this.rows[i].price)<=0){
              submit = 1
              this.rows[i].err_price = 'Invalid Price';
            }else if(price.test(this.rows[i].price)==false  && this.rows[i].price!=''){
              submit = 1
              this.rows[i].err_price = 'Invalid Price';
            }
            
            if(this.rows[i].salepricemd1==''){
              submit = 1
              this.rows[i].err_saleprice = 'Required';
            }else if(parseFloat(this.rows[i].salepricemd1)<=0){
              submit = 1
              this.rows[i].err_saleprice = 'Invalid Price';
            }else if(price.test(this.rows[i].salepricemd1)==false  && this.rows[i].salepricemd1!=''){
              submit = 1
              this.rows[i].err_saleprice = 'Invalid Price';
            }
            else if(parseFloat(this.rows[i].salepricemd1) < parseFloat(this.rows[i].price)){
              submit = 1
              this.rows[i].err_saleprice = 'Should be greater or equal to purchase price';
            }
            

            if(this.rows[i].qty==''){
              submit = 1
              this.rows[i].err_qty = 'Required';
            }else if(parseFloat(this.rows[i].qty)<=0.00){
              submit = 1
              this.rows[i].err_qty = 'Invalid Quantity';
            }else if(price.test(this.rows[i].qty)==false  && this.rows[i].qty != ''){
              submit = 1
              this.rows[i].err_qty = 'Invalid Quantity';
            }

            if(igstexp.test(this.rows[i]['igst'])==false && this.rows[i]['igst']!=''){
              this.rows[i]['igst']=''
              this.rows[i]['err_igst'] = 'Invalid';
              submit = 1
            }else if(parseFloat(this.rows[i]['igst'])<0){
              this.rows[i]['igst']=''
              this.rows[i]['err_igst'] = 'Invalid';
              submit = 1
            }

            if(tax.test(this.rows[i]['cgst'])==false  && this.rows[i]['cgst']!=0){
              this.rows[i]['cgst']=0
              this.rows[i]['err_cgst'] = 'Invalid';
              submit = 1
            }else if(parseFloat(this.rows[i]['cgst'])<0){
              this.rows[i]['cgst']=0
              this.rows[i]['err_cgst'] = 'Invalid';
              submit = 1
            }


            if(tax.test(this.rows[i]['sgst'])==false  && this.rows[i]['sgst']!=0){
              this.rows[i]['sgst']=0
              this.rows[i]['err_sgst'] = 'Invalid';
              submit = 1
            }else if(parseFloat(this.rows[i]['sgst'])<0){
              this.rows[i]['sgst']=0
              this.rows[i]['err_sgst'] = 'Invalid';
              submit = 1
            }
          }
        }



        if(this.selectedcustomer==null || this.selectedcustomer.supplier_id==null || this.selectshop==null || this.selectshop.est_shop_id==null){
          if(this.selectshop==null || this.selectshop.est_shop_id==null){
            this.haserror.shop="Please Select Shop"
          }
          if(this.selectedcustomer==null || this.selectedcustomer.supplier_id==null){
            this.haserror.cust="Please Select Supplier"
          }
        }else{
          for (var i = this.rows.length-1; i >=0;  i--) {
            if(this.rows[i].selectproductrow==null){
              this.rows.splice(i,1);
            }
          }
          if(this.rows.length==0){
            alert("Nothing to Save");
          }
          else{
            var _this=this
            if(this.detail.totalamtpay===''){
              alert("Nothing To Save");
            }else if(parseFloat(this.detail.totalamtpay) < 0){
              submit = 1
              alert("Invalid Entry" )
              
             // this.detail.addition='';
             // alert("Additional Discount Should Not Be Greater Than Total Amount Pay")
           }else{
            if(submit == 0){
              this.amt_rec = ''
              this.chequeno_validate=''
              this.chequedate_validate=''
              // if(this.selected_pytype === 'full'){
              //   if(parseInt(this.chng) < 0){
              //     this.amt_rec = 'Invalid Entry - Change Amt Cannot Be Negative - Please Select Valid Payment Type(Partial)'
              //     this.totalamtreceived = ''
              //     this.chng = 0
              //     return
              //   }
              //   this.detail.totalamtpendingpay = 0
              // }
              // else 
              /*if(this.selected_pytype === 'partial'){
                if(parseInt(this.totalparamtreceived) == 0 || this.totalparamtreceived == ''){
                  this.totalparamtreceived = ''
                  this.amt_rec = 'Required'
                  this.bal = 0
                  return                  
                }else if(parseInt(this.bal) < 0){
                  this.totalparamtreceived = ''
                  this.amt_rec = 'Invalid Entry - Balance Amount Cannot Be Negative - Please Select Valid Payment Type(Full)'
                  this.bal = 0
                  return
                }
                this.detail.totalamtpendingpay = this.bal
              }
              else if(this.selected_pytype === 'full'){
               this.detail.totalamtpendingpay = 0 
             }*/
             if (this.selected_pytype === 'partial') {
              var chk_partail=false

              if (parseInt(this.totalparamtreceived) == 0 || this.totalparamtreceived == '') {
                this.totalparamtreceived = ''
                this.amt_rec = 'Required'
                this.bal = 0                
                chk_partail=true
              }
              if (parseInt(this.bal) < 0) {
                this.totalparamtreceived = ''
                this.amt_rec = 'Invalid Entry - Balance Amount Cannot Be Negative - Please Select Valid Payment Type(Full)'
                this.bal = 0
                chk_partail=true

              }
              if(this.selected_pymode == 'cheque' && this.cheque_no == ''){
                this.chequeno_validate='Required'
                chk_partail=true
              }
              if(this.selected_pymode == 'cheque' && this.cheque_date == ''){
                this.chequedate_validate='Required'
                chk_partail=true
              }

              if (chk_partail == true) {
                return
              }
              
              this.detail.totalamtpendingpay = this.bal

            }else if(this.selected_pytype === 'full'){
              this.detail.totalamtpendingpay = 0
              var chk_full=false           
              if (this.selected_pymode == 'cheque' && this.cheque_no == '') {
                this.chequeno_validate='Required'
                chk_full=true
              }
              if(this.selected_pymode == 'cheque' && this.cheque_date == '') {
                this.chequedate_validate='Required'
                chk_full=true

              }                
              if (chk_full==true) {
                return
              }                
              
            }
            else{
              this.detail.totalamtpendingpay = this.detail.totalamtpay
            }

            if(this.cheque_date != ''){
              var daynum = /^[0-9]{1}$/
              let date = new Date(this.cheque_date)
              var year = date.getFullYear()
              var month = date.getMonth()+1;
              var day = date.getDate();

              if(daynum.test(month)==true){
                var month='0'+month
              }else{
                var month=month
              }

              if(daynum.test(day)==true){
                var day='0'+day
              }else{
                var day=day
              }
              var dateval = year+'-'+month+'-'+day
            }else{
              var dateval = null
            }
            
            this.loading=true  
            var data={}
            data.suppliersid=this.selectedcustomer.supplier_id
            data.shopid=this.selectshop.est_shop_id
            data.pur_items=this.rows
            data.total_discount=this.detail.totprddis
            data.additional=this.detail.addition
            data.amt_before_tax=this.detail.tot
            data.cgst=this.detail.cgst
            data.sgst=this.detail.sgst
            data.igst=this.detail.igst
            data.taxamt=this.detail.taxamt
            data.totalamtpay=this.detail.totalamtpay
            data.totalamtpendingpay = this.detail.totalamtpendingpay
            data.pay = {'paytype': '', 'paymode': '', 'chqno': '', 'chqdt': '', 'amt': 0}
            data.pay.paytype = this.selected_pytype
            data.pay.paymode = this.selected_pymode
            data.pay.chqno = this.cheque_no
            data.pay.chqdt = dateval
            data.pay.amt = parseFloat(this.detail.totalamtpay) - parseFloat(this.detail.totalamtpendingpay)
            this.$http.post('/api/purchases/postdata', data).then(function (response) {
              _this.loading = false; 
              document.body.scrollTop = 0;
              document.documentElement.scrollTop = 0;                                 
              _this.haserror.message= 'Purchase Added Successfully';
              setTimeout(function(){ _this.haserror.message='';}, 2000);
              _this.reset()
            })
            .catch(function (error) {
              _this.loading = false
              console.log(error.response)
            });
          }
        }
      }
    }
  },

  reset(){
    this.selectedcustomer=null
    this.detail.totprddis=''
    this.detail.addition=''
    this.detail.tot=''
    this.detail.cgst=''
    this.detail.sgst=''
    this.detail.igst=''
    this.detail.taxamt=''
    this.detail.totalamtpay=''
    this.detail.totalamtpendingpay=''
      // this.chng=0
      this.bal=0
      this.cheque_no=''
      this.cheque_date=''
      this.selected_pymode='cash'
      this.selected_pytype='full'
      for (var i = this.rows.length-1; i >=0;  i--) {
        this.rows.splice(i,1);
      }

      for (var i = 0; i <2; i++) {
        this.rows.push({ productnamex:[],selectedproductid:'',unit:'',unitvalue:'',selectproductrow:null,price:'', qty:'',amt:'', cgst:0, sgst:0,igst:'',amttotal:0,batchmd1:'',serialmd1:'',percentagemd1:'', amtmd1:'', variantrow:'n/a', inclusive1:false, salepricemd1:'', err_saleprice:'', is_adjustment:false, adjustment_list:[], adjusted:[], err_qty:'', err_price:'', err_sgst:'', err_cgst:'', err_igst:'',showvariant:false,novariant:false,productExist:''})
      }
    }
  }
}
</script>

<style type="text/css">
  .bell{
    -webkit-animation: ring 4s .7s ease-in-out infinite;
    -webkit-transform-origin: 50% 4px;
    -moz-animation: ring 4s .7s ease-in-out infinite;
    -moz-transform-origin: 50% 4px;
    animation: ring 4s .7s ease-in-out infinite;
    transform-origin: 50% 4px;
  }

  @-webkit-keyframes ring {
    0% { -webkit-transform: rotateZ(0); }
    1% { -webkit-transform: rotateZ(30deg); }
    3% { -webkit-transform: rotateZ(-28deg); }
    5% { -webkit-transform: rotateZ(34deg); }
    7% { -webkit-transform: rotateZ(-32deg); }
    9% { -webkit-transform: rotateZ(30deg); }
    11% { -webkit-transform: rotateZ(-28deg); }
    13% { -webkit-transform: rotateZ(26deg); }
    15% { -webkit-transform: rotateZ(-24deg); }
    17% { -webkit-transform: rotateZ(22deg); }
    19% { -webkit-transform: rotateZ(-20deg); }
    21% { -webkit-transform: rotateZ(18deg); }
    23% { -webkit-transform: rotateZ(-16deg); }
    25% { -webkit-transform: rotateZ(14deg); }
    27% { -webkit-transform: rotateZ(-12deg); }
    29% { -webkit-transform: rotateZ(10deg); }
    31% { -webkit-transform: rotateZ(-8deg); }
    33% { -webkit-transform: rotateZ(6deg); }
    35% { -webkit-transform: rotateZ(-4deg); }
    37% { -webkit-transform: rotateZ(2deg); }
    39% { -webkit-transform: rotateZ(-1deg); }
    41% { -webkit-transform: rotateZ(1deg); }

    43% { -webkit-transform: rotateZ(0); }
    100% { -webkit-transform: rotateZ(0); }
  }

  @-moz-keyframes ring {
    0% { -moz-transform: rotate(0); }
    1% { -moz-transform: rotate(30deg); }
    3% { -moz-transform: rotate(-28deg); }
    5% { -moz-transform: rotate(34deg); }
    7% { -moz-transform: rotate(-32deg); }
    9% { -moz-transform: rotate(30deg); }
    11% { -moz-transform: rotate(-28deg); }
    13% { -moz-transform: rotate(26deg); }
    15% { -moz-transform: rotate(-24deg); }
    17% { -moz-transform: rotate(22deg); }
    19% { -moz-transform: rotate(-20deg); }
    21% { -moz-transform: rotate(18deg); }
    23% { -moz-transform: rotate(-16deg); }
    25% { -moz-transform: rotate(14deg); }
    27% { -moz-transform: rotate(-12deg); }
    29% { -moz-transform: rotate(10deg); }
    31% { -moz-transform: rotate(-8deg); }
    33% { -moz-transform: rotate(6deg); }
    35% { -moz-transform: rotate(-4deg); }
    37% { -moz-transform: rotate(2deg); }
    39% { -moz-transform: rotate(-1deg); }
    41% { -moz-transform: rotate(1deg); }

    43% { -moz-transform: rotate(0); }
    100% { -moz-transform: rotate(0); }
  }

  @keyframes ring {
    0% { transform: rotate(0); }
    1% { transform: rotate(30deg); }
    3% { transform: rotate(-28deg); }
    5% { transform: rotate(34deg); }
    7% { transform: rotate(-32deg); }
    9% { transform: rotate(30deg); }
    11% { transform: rotate(-28deg); }
    13% { transform: rotate(26deg); }
    15% { transform: rotate(-24deg); }
    17% { transform: rotate(22deg); }
    19% { transform: rotate(-20deg); }
    21% { transform: rotate(18deg); }
    23% { transform: rotate(-16deg); }
    25% { transform: rotate(14deg); }
    27% { transform: rotate(-12deg); }
    29% { transform: rotate(10deg); }
    31% { transform: rotate(-8deg); }
    33% { transform: rotate(6deg); }
    35% { transform: rotate(-4deg); }
    37% { transform: rotate(2deg); }
    39% { transform: rotate(-1deg); }
    41% { transform: rotate(1deg); }
    43% { transform: rotate(0); }
    100% { transform: rotate(0); }
  }
  .modal-title{
    color:black;
    font-weight:bold;
  }
</style>



// WEBPACK FOOTER //
// src/views/purches/Addpurches.vue